import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { EXAMPLE_ARTICLES } from "../../lib/exampleData";
import SectionHeading from "../SectionHeading";
import { Reveal } from "../Reveal";
import { ExampleBadge } from "../EmptyState";
import NewsCard from "./NewsCard";

export default function HomeNews() {
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    api.get("/articles?limit=3").then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, []);

  const isExample = articles !== null && articles.length === 0;
  const list = articles === null ? [] : isExample ? EXAMPLE_ARTICLES : articles;

  return (
    <section className="bg-mist py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div className="flex items-start gap-4">
            <SectionHeading number="02" kicker="La vie du club" title={<>Actualités</>} />
            {isExample && <ExampleBadge className="mt-2" />}
          </div>
          <Reveal delay={0.2}>
            <Link
              to="/actualites"
              data-testid="news-see-all"
              className="group inline-flex items-center gap-3 border border-navy/25 text-navy font-heading uppercase tracking-wider text-sm px-6 py-3.5 hover:border-rouge hover:text-rouge transition-[border-color,color] duration-300"
            >
              Voir toutes les actualités
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>

        <div data-testid="home-news-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.1}>
              <NewsCard article={a} index={i} example={isExample} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
